// extracted by mini-css-extract-plugin
export default {"field":"ProjectDetailsFieldVisibillityFIeld_field__A1sdN","visible":"ProjectDetailsFieldVisibillityFIeld_visible__vXi9f","hidden":"ProjectDetailsFieldVisibillityFIeld_hidden__GaAs4"};